import angular from 'angular';
import template from './template.html';
import './style.scss';

export class SummarySection {}

export const SummarySectionConfiguration = {
    template,
    controller: SummarySection,
    bindings: {
        executiveSummary: '<',
        canEdit: '<',
    },
    controllerAs: 'summarySectionCtrl'
};

angular.module('TALENYA-FE').component('candidateSummarySection', SummarySectionConfiguration);
